import { AiOutlineMore } from 'react-icons/ai';
import { Button, ButtonProps } from 'antd';
import { styled } from 'styled-components';
import React, { useMemo } from 'react';
import { IconButton_ButtonSizes, IconButton_IconSizes, IconButtonSize } from '@ydistri/ds';

// Sized from the design system's own table rather than the ds IconButton itself: that one calls
// stopPropagation on click, so as a Dropdown trigger it would swallow the click that opens the menu.
const StyledButton = styled(Button)<{ $size: IconButtonSize }>`
  width: ${({ $size }) => IconButton_ButtonSizes[$size]};
  height: ${({ $size }) => IconButton_ButtonSizes[$size]};
  border-color: transparent;
  background-color: transparent;

  &:hover {
    border-color: transparent !important;
    background-color: transparent !important;
  }
`;

interface MoreIconButtonProps extends Omit<ButtonProps, 'icon' | 'size'> {
  size?: IconButtonSize;
}

const MoreIconButton: React.FC<MoreIconButtonProps> = ({ size = 'small', ...rest }) => {
  const icon = useMemo(() => <AiOutlineMore size={IconButton_IconSizes[size]} />, [size]);

  return <StyledButton $size={size} icon={icon} {...rest} />;
};

export default MoreIconButton;
